module.exports = __webpack_public_path__ + "img/Weapon_131.e7ce8cee.png";